import { render, staticRenderFns } from "./SendWearArmbandNotice.vue?vue&type=template&id=509fce8f"
import script from "./SendWearArmbandNotice.vue?vue&type=script&lang=js"
export * from "./SendWearArmbandNotice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports